import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

export default function withRouter(Component)
{
    return React.forwardRef( (props, ref) =>
    {
        let location = useLocation();
        let navigate = useNavigate();
        let [search, setSearchParams] = useSearchParams();
        let params = useParams();
        return (
            <Component
                ref={ref}
                {...props}
                router={{ location, navigate, search, setSearchParams, params }}
            />
        );
    });
}